import styled from "styled-components";
import LoadingBox from "../../shared/LoadingBox";

const CenteredLayout = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    box-sizing: border-box;
    min-height: 100vh;
    align-items: center;
    justify-content: center;
    height: 100%;
`;

export function AdminLoadingPage() {
  return (
    <CenteredLayout>
      <LoadingBox text="Loading admin panel" />
    </CenteredLayout>
  );
}
